//
//
//
//
//
//
//
//
//
//
//
//

import ClipboardJS from "clipboard";
export default {
  name: "window",
  data: () => {},
  mounted() {
    this.init();
  },
  methods: {}
};

document.addEventListener("WeixinJSBridgeReady", function onBridgeReady() {
  // 通过下面这个API隐藏右上角按钮
  WeixinJSBridge.call("hideOptionMenu"); // 通过下面这个API隐藏底部导航栏
  WeixinJSBridge.call("hideToolbar");
});



// WEBPACK FOOTER //
// ./src/page/AlipayRedEnvelope/ncljlPromote.vue